mutation CreateSession($name: String!, $role: SessionRole!) {
	session: createSession(name: $name, role: $role) {
		token
	}
}
